import { selectInternalWidgets, updateWidgetPropertyByPath, useAppDispatch, useAppStore } from '@libs/store';
import { IUpdateWidgetPropertyByPath, TCommonData, TWidget } from '@libs/types';
import { calculateFunctions, getFunctionsObject } from '@libs/utils';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

export const useFunction = (widget: TWidget<TCommonData>) => {
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const { internalIds, functionObjects } = getFunctionsObject(widget.functions);

    useEffect(() => {
        if (internalIds.size === 0) return;

        const dispatchPropertyUpdate = (payload: IUpdateWidgetPropertyByPath) => {
            dispatch(updateWidgetPropertyByPath(payload));
        };

        let lastInternalWidgets = selectInternalWidgets(store.getState(), internalIds);
        calculateFunctions(widget, functionObjects, lastInternalWidgets, dispatchPropertyUpdate);

        return store.subscribe(() => {
            const next = selectInternalWidgets(store.getState(), internalIds);
            if (shallowEqual(lastInternalWidgets, next)) return;
            lastInternalWidgets = next;
            calculateFunctions(widget, functionObjects, next, dispatchPropertyUpdate);
        });
    }, [dispatch, functionObjects, internalIds, store, widget]);
};
